import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { SHARED_ENVIRONMENT } from "@k12/environment";
import { Comment } from "@k12/models";
import { Observable, Subject } from "rxjs";
import { IUserRecordCommentsService } from '../tokens/user-record-host-services.token';

@Injectable({
  providedIn: 'root'
})
export class CommentsService implements IUserRecordCommentsService {

  private readonly http = inject(HttpClient);
  private readonly sharedEnvironment = inject(SHARED_ENVIRONMENT);
  private readonly refreshNotesSubject = new Subject<{ action: string, comment?: Comment }>();
  refreshComments$ = this.refreshNotesSubject.asObservable();

  getComments(programPartnerId: string, commentType: number): Observable<Comment[]> {
    const params = { programPartnerId, commentType: commentType.toString() }
    return this.http.get<Comment[]>(`${this.sharedEnvironment.adminApiUrl}/partners/comments`, { params });
  }

  saveComment(payload: Comment): Observable<Comment> {
    return this.http.post<Comment>(`${this.sharedEnvironment.adminApiUrl}/partners/comment`, payload);
  }

  archiveComment(commentId: string): Observable<void> {
    return this.http.delete<void>(`${this.sharedEnvironment.adminApiUrl}/partners/comments/${commentId}`);
  }

  refreshComments(action: string = 'save', comment?: Comment,): void {
    this.refreshNotesSubject.next({ comment, action });
  }
}